/**
 * PDP Promo countdown banner
 * Supports one-shot end date and looping countdown cycles.
 */
(function () {
  var REFRESH_MS = 1000;

  function pad2(n) {
    var v = String(Math.max(0, Math.floor(Number(n) || 0)));
    return v.length >= 2 ? v : ('0' + v).slice(-2);
  }

  var TIME_PART = '(?:[T\\s](\\d{1,2}):(\\d{2})(?::(\\d{2}))?)?';
  var YMD_RE = new RegExp('^(\\d{4})-(\\d{1,2})-(\\d{1,2})' + TIME_PART);
  var DMY_RE = new RegExp('^(\\d{1,2})-(\\d{1,2})-(\\d{4})' + TIME_PART);

  function parseLocalDateTime(value) {
    if (!value) return null;
    var raw = String(value).trim();
    if (!raw) return null;

    // Translate & Adapt localises date settings, so the same date can arrive
    // as 2026-08-01 or 01-08-2026 / 01/08/2026 depending on the storefront locale.
    var normalized = raw.replace(/[./]/g, '-');
    var year;
    var month;
    var day;
    var m = normalized.match(YMD_RE);

    if (m) {
      year = m[1];
      month = m[2];
      day = m[3];
    } else {
      m = normalized.match(DMY_RE);
      if (m) {
        day = m[1];
        month = m[2];
        year = m[3];
      }
    }

    if (m) {
      // Prefer local time construction (avoid UTC parse of bare date strings)
      return new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(m[4] || 0),
        Number(m[5] || 0),
        Number(m[6] || 0)
      );
    }

    var d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  }

  function getLoopEndMs(banner) {
    var days = parseInt(banner.getAttribute('data-loop-days') || '0', 10) || 0;
    var hours = parseInt(banner.getAttribute('data-loop-hours') || '0', 10) || 0;
    var cycleMs = (days * 24 + hours) * 60 * 60 * 1000;
    if (cycleMs <= 0) return null;

    var now = Date.now();
    var start = parseLocalDateTime(banner.getAttribute('data-loop-start'));
    var startMs;

    if (start) {
      startMs = start.getTime();
    } else {
      // Anchor the fallback once. Re-deriving it from "now" on every tick would
      // keep the remaining time pinned to a full cycle, i.e. a frozen timer.
      if (!banner._pdpPromoFallbackStart) banner._pdpPromoFallbackStart = now;
      startMs = banner._pdpPromoFallbackStart;
    }

    if (now < startMs) return startMs;

    var elapsed = now - startMs;
    var cycleIndex = Math.floor(elapsed / cycleMs);
    return startMs + (cycleIndex + 1) * cycleMs;
  }

  function getTargetMs(banner) {
    if (banner.getAttribute('data-countdown-loop') === 'true') {
      return getLoopEndMs(banner);
    }
    var end = parseLocalDateTime(banner.getAttribute('data-countdown-end'));
    return end ? end.getTime() : null;
  }

  function timerValueEls(banner) {
    var daysEl = banner.querySelector('[data-promo-days]');
    var hoursEl = banner.querySelector('[data-promo-hours]');
    var minutesEl = banner.querySelector('[data-promo-minutes]');
    var secondsEl = banner.querySelector('[data-promo-seconds]');

    // Fallback if a translation layer stripped data-* from some units
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      var values = banner.querySelectorAll('.pdp-promo-banner__timer-value');
      daysEl = daysEl || values[0] || null;
      hoursEl = hoursEl || values[1] || null;
      minutesEl = minutesEl || values[2] || null;
      secondsEl = secondsEl || values[3] || null;
    }

    return {
      daysEl: daysEl,
      hoursEl: hoursEl,
      minutesEl: minutesEl,
      secondsEl: secondsEl
    };
  }

  function renderTimer(banner, remainingMs) {
    var totalSec = Math.max(0, Math.floor(remainingMs / 1000));
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;
    var els = timerValueEls(banner);

    if (els.daysEl) els.daysEl.textContent = pad2(days);
    if (els.hoursEl) els.hoursEl.textContent = pad2(hours);
    if (els.minutesEl) els.minutesEl.textContent = pad2(minutes);
    if (els.secondsEl) els.secondsEl.textContent = pad2(seconds);
  }

  function bannerIsLive(banner) {
    return !!(banner && banner.isConnected !== false && document.contains(banner));
  }

  function syncBannerCopy(banner) {
    if (!banner) return;
    var locale = 'en';
    if (window.SuaveLocale && typeof window.SuaveLocale.getCurrentLocaleCode === 'function') {
      locale = window.SuaveLocale.getCurrentLocaleCode();
    } else if ((window.location.pathname || '') === '/es' || (window.location.pathname || '').indexOf('/es/') === 0) {
      locale = 'es';
    } else if (banner.getAttribute('data-promo-locale') === 'es') {
      locale = 'es';
    }
    banner.querySelectorAll('[data-promo-copy][data-en][data-es]').forEach(function (el) {
      var text = el.getAttribute(locale === 'es' ? 'data-es' : 'data-en');
      if (text != null && String(text).trim() !== '') el.textContent = text;
    });
  }

  function tickBanner(banner) {
    try {
      if (!bannerIsLive(banner)) return false;
      var targetMs = getTargetMs(banner);
      if (targetMs == null) {
        renderTimer(banner, 0);
        return false;
      }
      var remaining = targetMs - Date.now();
      if (remaining <= 0) {
        if (banner.getAttribute('data-countdown-loop') === 'true') {
          targetMs = getLoopEndMs(banner);
          remaining = targetMs != null ? targetMs - Date.now() : 0;
        } else {
          remaining = 0;
        }
      }
      renderTimer(banner, remaining);
      return remaining > 0 || banner.getAttribute('data-countdown-loop') === 'true';
    } catch (err) {
      return bannerIsLive(banner);
    }
  }

  function clearBannerTimer(banner) {
    var existing = banner && banner._pdpPromoTimerId;
    if (existing) {
      window.clearInterval(existing);
      banner._pdpPromoTimerId = null;
    }
    if (banner) banner.removeAttribute('data-promo-timer-bound');
  }

  function initBanner(banner, force) {
    if (!banner) return;
    if (!banner.querySelector('.pdp-promo-banner__timer') && !banner.querySelector('[data-promo-days]')) {
      return;
    }

    if (!force && banner.getAttribute('data-promo-timer-bound') === '1' && banner._pdpPromoTimerId) {
      return;
    }

    clearBannerTimer(banner);
    banner.setAttribute('data-promo-timer-bound', '1');
    syncBannerCopy(banner);

    tickBanner(banner);
    banner._pdpPromoTimerId = window.setInterval(function () {
      if (!bannerIsLive(banner)) {
        clearBannerTimer(banner);
        initAll(document, true);
        return;
      }
      var keepGoing = tickBanner(banner);
      if (!keepGoing) clearBannerTimer(banner);
    }, REFRESH_MS);
  }

  function initAll(root, force) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-promo-banner]').forEach(function (banner) {
      initBanner(banner, !!force);
    });
  }

  function boot() {
    initAll(document, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target, true);
  });

  // Locale toggle / bfcache can leave a dead interval or replaced timer nodes
  window.addEventListener('pageshow', function () {
    initAll(document, true);
  });

  document.addEventListener('suave:localechange', function () {
    window.setTimeout(function () {
      initAll(document, true);
    }, 0);
  });
})();
